import { Suspense, type PropsWithChildren } from 'react'
import { Outlet } from 'react-router-dom'

import { LocationInputProvider } from 'src/shared/features/users/components/marketplace/context/use-location-input'
import PublicProfileSkeleton from 'src/shared/features/users/components/public-profile/skeleton/public-profile-skeleton'
import PublicProfileHeader from 'src/shared/features/users/components/public-profile/ui/header'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

const PublicProfileLayoutContent = ({ children, profile = false }: PropsWithChildren<{ profile?: boolean }>) => {
  const { width } = useWindowSize()

  return (
    <LocationInputProvider>
      <div className="flex min-h-screen w-full flex-col">
        <div className="flex w-full items-center justify-center md:px-8">
          <PublicProfileHeader />
        </div>
        <main className="mx-auto w-full px-0 md:px-8">
          {profile && width > 768 ? (
            <div>{children || <Outlet />}</div>
          ) : (
            <div className="flex w-full flex-col gap-4">
              <div className="w-full">{children || <Outlet />}</div>
            </div>
          )}
        </main>
      </div>
    </LocationInputProvider>
  )
}

const PublicProfileLayout = ({ children, profile = false }: PropsWithChildren<{ profile?: boolean }>) => {
  return (
    <Suspense fallback={<PublicProfileSkeleton />}>
      <PublicProfileLayoutContent profile={profile}>{children}</PublicProfileLayoutContent>
    </Suspense>
  )
}

export default PublicProfileLayout
